export const HTTP_TIMEOUT_DEFAULT = 20_000

export function requirePublicApiBaseUrl(): string {
  const base = process.env.NEXT_PUBLIC_API_URL
  if (!base) {
    throw new Error(
      'NEXT_PUBLIC_API_URL is required: set it to your API host (e.g. https://dev-dcorp-web-api.dcorp.com.vn).',
    )
  }
  return base
}
